export default {
  translation: {
    actions: {
      goBack: 'Ir atrás',
      search: 'Buscar país',
      logout: 'Cerrar sesión',
    },
    dates: {
      year: 'Año',
      month: 'Mes',
      day: 'Día',
      display: {
        withYear: "dd 'de' LLL yyyy",
        withoutYear: "dd 'de' LLL",
      },
    },
    apiErrors: {
      unauthorized: {
        message: 'Sesión expirada',
        description: 'Tu sesión no es válida, debes iniciar sesión de nuevo',
      },
      forbidden: {
        message: 'Prohibido',
        description: 'No tienes autorización para realizar esta acción',
      },
      notFound: {
        message: 'No se encontró',
        description: 'No se encontró el recurso que solicitaste',
      },
      serverError: {
        message: 'Error',
        description: 'Hubo un error al procesar tu solicitud, por favor intenta más tarde',
      },
      answerFriendshipRequest: {
        message: '¡Ups!',
        description: 'Hubo un problema al responder esta solicitud de amistad',
      },
      phoneValidation: {
        message: '¡Ups!',
        description: 'Hubo un problema al validar tu número telefónico',
      },
      invalidShareableToken: {
        message: '¡Ups!',
        description: 'Al parecer el link que usaste ya no es válido',
      },
    },
    answerRequest: {
      cancelText: 'cancelar',
      reason: 'Esto ayudará a tus amigos a estar seguros que recordarán tu cumpleaños.',
      withYear: 'Con Año',
      withoutYear: 'Sin Año',
      submit: 'Compartir con {{inviterName}}',
      confirmText: 'Ok',
      failed: '¡Ups! ¡Hubo un problema al contestar tu cumpleaños!',
      withSession: {
        submit: 'Compartir',
        title: '{{currentUserName}}, ayuda a {{inviterName}} a celebrar tu cumpleaños.',
        shareInformation: 'Estás por compartir a {{inviterName}} la siguiente información:',
        clearSession: '¿No eres {{currentUserName}}? Cerrar sesión',
      },
      shareableLinks: {
        title: 'Ayuda a {{inviterName}} a celebrar tu cumpleaños.',
      },
      directLinks: {
        title: '{{invitedName}}, ayuda a {{inviterName}} a celebrar tu cumpleaños.',
      },
      rememberMe: 'Recordarme',
    },
    phoneValidation: {
      explanation: {
        mandatory: 'Encontramos que este número telefónico ya está en Cupcake con distinta información personal. Te enviamos un código de verificación vía SMS para mantener la cuenta segura.',
        voluntaryBeginning: 'Gracias por compartir tu cumpleaños con {{inviterName}}. Ya está todo listo.',
        voluntaryEnding: 'Si quieres registrarte y recordar el cumpleaños de {{inviterName}}, verifica tu número telefónico abajo.',
      },
      smsButton: 'Enviar código verificador vía SMS',
      skipButton: 'Saltar',
      form: {
        instructions: 'Ingresa el código de {{length}} dígitos que te enviamos vía SMS',
        submit: 'Verificar',
        resendSMS: 'Reenviar SMS al número {{phoneNumber}}',
        error: {
          message: '¡Ups!',
          description: 'Hubo un problema al validar tu código SMS. Revisa si lo ingresaste correctamente',
        },
      },
    },
    downloadLinks: {
      thankYou: '¡Gracias!',
      downloadTheApp: 'No te pierdas los cumpleaños de tus amigos.',
      iOSBetaExplanation: 'Para probar la aplicación en iOS necesitarás descargar TestFlight desde la App Store. Tan solo sigue las instrucciones del botón a continuación.',
      androidBetaExplanation: 'Para probar la aplicación en Android necesitas primero <0>unirte al Google Group de testers aquí</0>, y luego podrás descargar la aplicación desde el siguiente botón.',
    },
    termsOfService: {
      title: 'Términos del Servicio',
    },
    privacyPolicy: {
      title: 'Política de Privacidad de Cupcake',
    },
    user: {
      countryCode: 'Código de país',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phoneNumber: 'Teléfono',
      name: 'Nombre',
      birthday: 'Cumpleaños',
    },
    validations: {
      required: 'Requerido',
      invalidPhoneNumber: 'Número telefónico inválido',
      digitCodeLength: 'Debe ser un código de {{length}} dígitos de largo',
    },
    feedback: {
      logout: {
        message: 'Cerraste sesión',
      },
    },
  },
};
